export default __webpack_public_path__ + "static/media/header.996a74d5.png";